import React from 'react';
import SectionHeader from './SectionHeader';
import Form from './Form';
import './SectionContactUsForm.css';
import R from 'ramda';
import {contactUsForm} from '../data';

export function toggleFormSubmitted() {
    return ( {formSubmitted: true} );
}

export function toggleFormSubmitFail(bool) {
  return function update() {
    return bool ? {formSubmitFailed: true} : {formSubmitFailed: false};
  }
}

class SectionContactUsForm extends React.Component {
  constructor() {
    super();
    this.state = {
      formSubmitted: false,
      formSubmitFailed: false
    }
  }

  handleToggleFormSubmitted() {
    this.setState(toggleFormSubmitted);
  }

  handleToggleFormSubmitFail(bool) {
    this.setState(toggleFormSubmitFail(bool));
  }

  render() {
    const {sectionHeaderForm, sectionHeaderComplete} = contactUsForm;
    const formSubmitted = R.prop('formSubmitted', this.state);
    const formSubmitFailed = R.prop('formSubmitFailed', this.state);
    function formHeaderText() {
      if (formSubmitFailed) {
        sectionHeaderForm.bodyText = 'Form Submission Failed.  Please Try Again';
        return sectionHeaderForm;
      } else {
        return formSubmitted ? sectionHeaderComplete : sectionHeaderForm;
      }
    }

    return (
      <section id='get-in-contact'>
        <SectionHeader item={formHeaderText()} />
        {formSubmitted ? '' :
        <Form
          toggleFormSubmitted={() => this.handleToggleFormSubmitted()} toggleFormSubmitFail={(succeedOrFailed) => this.handleToggleFormSubmitFail(succeedOrFailed)}
          formSubmitFailed={this.state.formSubmitFailed}
        />}

      </section>
    )
  }
}

export default SectionContactUsForm;



// WEBPACK FOOTER //
// ./src/components/SectionContactUsForm.js